// InitialFilterTabs.jsx
import * as React from 'react';
import { useListContext } from 'react-admin';
import { Tabs, Tab } from '@mui/material';

const kanaHeaders = [
  { key: '', label: '全て' },
  { key: 'ア', label: 'ア' },
  { key: 'カ', label: 'カ' },
  { key: 'サ', label: 'サ' },
  { key: 'タ', label: 'タ' },
  { key: 'ナ', label: 'ナ' },
  { key: 'ハ', label: 'ハ' },
  { key: 'マ', label: 'マ' },
  { key: 'ヤ', label: 'ヤ' },
  { key: 'ラ', label: 'ラ' },
  { key: 'ワ', label: 'ワ' },
];

export const InitialFilterTabs = () => {
  const { filterValues, setFilters } = useListContext();
  // filterValues.initial にタブ key が入る想定
  const current = filterValues.initial || '';

  const handleChange = (_, newKey) => {
    setFilters({
      // existing filters…
      ...filterValues,
      // all のときは initial を消す
      ...(newKey === '' ? { initial: undefined } : { initial: newKey })
    }, {});
  };

  return (
    <Tabs
      orientation="vertical"
      value={current}
      onChange={handleChange}
      variant="scrollable"
      sx={{ borderRight: 1, borderColor: 'divider', minWidth: 72 }}
    >
      {kanaHeaders.map(({ key, label }) => (
        <Tab key={key} label={label} value={key} />
      ))}
    </Tabs>
  );
};
